// Captura e mapeamento de origem do lead (UTMs).
//
// Guardado em localStorage (não sessionStorage) porque um visitante pode
// clicar num anúncio hoje e só preencher o orçamento dias depois — queremos
// a origem da visita que trouxe o UTM, não só a da última sessão.
//
// Sobrescreve o valor salvo só quando a URL atual TRAZ parâmetros utm_*
// novos (última campanha com clique vence); uma navegação interna sem
// utm_* preserva o que já estava guardado.

const STORAGE_KEY = "mn_utm";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];

function readFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) found[key] = value.slice(0, 160);
  }
  return found;
}

/** Chamar uma vez, no boot do app (ver App.js), pra capturar UTMs da URL de entrada. */
export function captureUtmFromUrl() {
  const found = readFromUrl();
  if (Object.keys(found).length === 0) return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
  } catch {
    // localStorage bloqueado (modo privado restrito etc.) — sem persistência,
    // sem problema: o formulário só vai sem dados de origem.
  }
}

/** Usado pelo hook de envio do formulário de orçamento. */
export function getStoredUtm() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}
